import React from 'react';
import { PROPERTY_TYPES } from '../../services/branding';

import ColorEditor from '../color-editor/color-editor';
import FontEditor from '../font-editor/font-editor';
import SizeEditor from '../size-editor/size-editor';
import StringEditor from '../string-editor/string-editor';
import UrlEditor from '../url-editor/url-editor';

import './editor.less';

export default class Editor extends React.Component {
    render() {
        const { type, style, disabled, readOnly, ...props } = this.props;
        const value = style ? style.value : '';

        switch ( type ) {
            case PROPERTY_TYPES.COLOR:
                return <ColorEditor { ...props } style={ style } value={ value } disabled={ disabled } readOnly={ readOnly } />;
            case PROPERTY_TYPES.FONT:
                return <FontEditor { ...props } style={ style } value={ value } disabled={ disabled } readOnly={ readOnly } />;
            case PROPERTY_TYPES.SIZE:
                return <SizeEditor { ...props } style={ style } value={ value } disabled={ disabled } readOnly={ readOnly } />;
            case PROPERTY_TYPES.STRING:
                return <StringEditor { ...props } style={ style } value={ value } disabled={ disabled } readOnly={ readOnly } />;
            case PROPERTY_TYPES.URL:
                return <UrlEditor { ...props } style={ style } value={ value } disabled={ disabled } readOnly={ readOnly } />;
            default:
                return <span>Unsupported Type { type }</span>;
        }
    }
}
